// public/models/onBoarding/stepIds.js

export default {
  FINISH_STEP: 0,
  ADD_TASK_STEP: 1,
  TASKS_CONNECTION_STEP: 2,
  ASSIGN_TASK_STEP: 3,
  CUSTOM_COLUMS_STEP: 4,
};
